import { __assign } from "tslib";
import { performanceLoggingSupported } from './utils/performanceLoggingSupported';
export function getBrowserTimingMeasures(handleError, commonParams) {
    var dump = new Array();
    if (!performanceLoggingSupported()) {
        return dump;
    }
    var globalWhitelistedMarkers = new Map([
        [
            "fetchStart" /* FetchStart */,
            "navigationStart" /* NavigationStart */,
        ],
        [
            "unloadEventStart" /* UnloadEventStart */,
            "navigationStart" /* NavigationStart */,
        ],
        [
            "unloadEventEnd" /* UnloadEventEnd */,
            "unloadEventStart" /* UnloadEventStart */,
        ],
        [
            "domainLookupEnd" /* DomainLookupEnd */,
            "domainLookupStart" /* DomainLookupStart */,
        ],
        ["connectEnd" /* ConnectEnd */, "connectStart" /* ConnectStart */],
        [
            "requestStart" /* RequestStart */,
            "navigationStart" /* NavigationStart */,
        ],
        [
            "responseStart" /* ResponseStart */,
            "requestStart" /* RequestStart */,
        ],
        [
            "responseEnd" /* ResponseEnd */,
            "responseStart" /* ResponseStart */,
        ],
        ["domLoading" /* DomLoading */, "responseStart" /* ResponseStart */],
        [
            "domInteractive" /* DomInteractive */,
            "domLoading" /* DomLoading */,
        ],
        ["domComplete" /* DomComplete */, "domLoading" /* DomLoading */],
    ]);
    // Add all the browser timing info (see http://www.w3.org/TR/navigation-timing/#processing-model)
    for (var marker in window.performance.timing) {
        // Limit only to browser markers that we are interested in
        var relativeMarker = globalWhitelistedMarkers.get(marker);
        if (!relativeMarker) {
            continue;
        }
        var value = window.performance.timing[marker];
        var relativeValue = window.performance.timing[relativeMarker];
        // Do not record measure when value for marker and/or relative marker is not a number, indicating some sort of bad state of performance.timing
        if (typeof value !== 'number' || typeof relativeValue !== 'number') {
            handleError(marker, "Failed to calculate measure for <" + marker + "> starting from <" + relativeMarker + "> due to unexpected value type: <" + marker + "> value type is " + typeof value + "; <" + relativeMarker + "> value type is " + typeof relativeValue);
            continue;
        }
        // Do not record measure when value for marker and/or relative marker is '0', indicating that corresponding moment never happened
        if (value === 0 || relativeValue === 0) {
            // Unload markers are expected to have zero value when it was fresh page load or unloaded page was from different domain
            if (marker !== "unloadEventStart" /* UnloadEventStart */ &&
                marker !== "unloadEventEnd" /* UnloadEventEnd */) {
                handleError(marker, "Failed to calculate measure for <" + marker + "> starting from <" + relativeMarker + "> due to unexpected zero values: <" + marker + ">=" + value + "; <" + relativeMarker + ">=" + relativeValue);
            }
            continue;
        }
        // Marker value should not be less than the one recorded for relative marker
        if (value < relativeValue) {
            handleError(marker, "Failed to calculate measure for <" + marker + "> starting from <" + relativeMarker + "> due to relative marker value being greater than marker value: <" + marker + ">=" + value + "; diff from <" + relativeMarker + ">=" + (value - relativeValue));
            continue;
        }
        // All marker values must be greater or equal to navigationStart
        if (value < window.performance.timing.navigationStart) {
            handleError(marker, "Failed to calculate measure for <" + marker + "> starting from <" + relativeMarker + "> due to marker value being less than <navigationStart> marker value: <" + marker + ">=" + value + "; diff from <navigationStart}>=" + (value - window.performance.timing.navigationStart));
            continue;
        }
        if (relativeValue < window.performance.timing.navigationStart) {
            handleError(marker, "Failed to calculate measure for <" + marker + "> starting from <" + relativeMarker + "> due to relative marker value being less than <navigationStart> marker value: <" + marker + ">=" + value + "; <" + relativeMarker + ">=" + relativeValue + "; diff from <navigationStart}>=" + (relativeValue - window.performance.timing.navigationStart));
            continue;
        }
        var duration = Math.ceil(value - relativeValue);
        dump.push({
            name: marker,
            duration: duration,
            params: !commonParams ? {} : __assign({}, commonParams),
        });
        // In older versions of Firefox (<= 52) if the measure name provided to
        // performance.measure() is a known browser marker name (like 'navigationStart' etc),
        // a "illegal string" error is thrown. This suffix is added to all measure names to avoid
        // this exception. performance_dump entries will not have this prefix, but it will show up
        // in the browser's performance measure viewer.
        var measureName = marker + "_ohp_measure";
        // Record measure so it shows up in Dev tools
        // BUGBUG: The following call may fail on older version of Firefox browsers when Firefox deem start and/or marker values to be invalid.
        // Wrapping into try/catch so we have direct way of checking how often it happens. Consider removing try/catch in case this is no longer happening.
        try {
            window.performance.measure(measureName, relativeMarker, marker);
        }
        catch (ex) {
            handleError(marker, "Failed to record measure for <" + marker + "> starting from <" + relativeMarker + ">: exception is thrown");
        }
    }
    return dump;
}
//# sourceMappingURL=getBrowserTimingMeasures.js.map